import {SmtPublication} from "../../utils/types";
import React, {ReactElement} from "react";
import {Link} from "react-router-dom";
import {Divider, Typography} from "antd";
import { toSafeInnerHTML } from '../../utils/utils';
import Collapsible from "../Collapsible";

import ComponentFromString from "../../utils/ComponentFromString";


interface Props {
    smtPub: SmtPublication
}

const SmtPublicationDescription = ({smtPub}: Props) => {

    const description = smtPub &&  <>
      {smtPub.resource_type &&
      <span
            dangerouslySetInnerHTML={{ __html: 
              `<strong><em>Type: </em></strong>${toSafeInnerHTML(smtPub.resource_type)} <br />` 
            }}>
      </span>}
      {smtPub.date_created &&
      <span
            dangerouslySetInnerHTML={{ __html: 
              `<strong><em>Date: </em></strong>${toSafeInnerHTML(smtPub.date_created)} <br />` 
            }}>
      </span>}
      {smtPub.authors &&
      <span
            dangerouslySetInnerHTML={{ __html: 
              `<strong><em>Authors: </em></strong>${toSafeInnerHTML(smtPub.authors)} <br />` 
            }}>
      </span>}
      {smtPub.publication_title &&
      <span
            dangerouslySetInnerHTML={{ __html: 
              `<strong><em>Authors: </em></strong>${toSafeInnerHTML(smtPub.publication_title)} <br />` 
            }}>
      </span>}
      {smtPub.thesis_advisor &&
      <span
            dangerouslySetInnerHTML={{ __html: 
              `<strong><em>Authors: </em></strong>${toSafeInnerHTML(smtPub.thesis_advisor)} <br />` 
            }}>
      </span>}


      {smtPub.sfu_authors &&
      <span>
          <strong>SFU faculty authors</strong>: {smtPub.sfu_authors.map(
          (author, index) => (
              <React.Fragment key={index}>
                  <Link to={`/profile/${author.random_id}`}>
                      <span className='gray-link-button'>{author.preferred_last_name}, {author.preferred_first_name && `${author.preferred_first_name[0]}.`}</span>
                  </Link>
                  {index !== smtPub.sfu_authors.length - 1 &&
                  <Divider type='vertical' style={{margin: '0 0.3em'}}/>}
              </React.Fragment>
          )
      )}<br/>
      </span>}


      {smtPub.abstract&&<Collapsible
        maxRowNum={2}
      >
        <strong>Abstract: </strong>
        {ComponentFromString(smtPub.abstract)}
      </Collapsible>}
    </>;

    return description as ReactElement;
};

export default SmtPublicationDescription;